import z from "zod";

export enum RelationshipToSubscriber {
  SELF = "Self",
  SPOUSE = "Spouse",
  CHILD = "Child",
  OTHER = "Other",
}

export const relationshipToSubscriberSchema = z.nativeEnum(RelationshipToSubscriber);
